import {
  FETCH_BRANDING_ASYNC,
  FETCH_TENANT_DOMAINS_ASYNC,
  RESET_SAVE_SUCCESS,
  SAVE_BRANDING_ASYNC,
  SELECT_DOMAIN,
} from './constants'

export const fetchBranding = () => ({ type: FETCH_BRANDING_ASYNC.INITIATE })
export const fetchBrandingSuccess = (data) => ({
  type: FETCH_BRANDING_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchBrandingError = (error) => ({ type: FETCH_BRANDING_ASYNC.ERROR, error })

export const saveBranding = (payload) => ({ type: SAVE_BRANDING_ASYNC.INITIATE, payload })
export const saveBrandingSuccess = (data) => ({
  type: SAVE_BRANDING_ASYNC.SUCCESS,
  payload: { data },
})
export const saveBrandingError = (error) => ({ type: SAVE_BRANDING_ASYNC.ERROR, error })

export const fetchTenantDomains = () => ({ type: FETCH_TENANT_DOMAINS_ASYNC.INITIATE })
export const fetchTenantDomainsSuccess = (domains) => ({
  type: FETCH_TENANT_DOMAINS_ASYNC.SUCCESS,
  payload: { domains },
})
export const fetchTenantDomainsError = (error) => ({
  type: FETCH_TENANT_DOMAINS_ASYNC.ERROR,
  error,
})

export const selectDomain = (domain) => ({ type: SELECT_DOMAIN, payload: { domain } })
export const resetSaveSuccess = () => ({ type: RESET_SAVE_SUCCESS })

export default {
  fetchBranding,
  fetchTenantDomains,
  saveBranding,
  selectDomain,
  resetSaveSuccess,
}
